module.exports = [
	{
		clinic_id: '2',
		clinic_sn: '3505320260',
		name: '東寧',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '3',
		clinic_sn: '3505340379',
		name: '西門',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '4',
		clinic_sn: '3505320779',
		name: '青年',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '5',
		clinic_sn: '3507330282',
		name: '中山',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '6',
		clinic_sn: '3507301307',
		name: '博愛',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '7',
		clinic_sn: '3503272707',
		name: '文心',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '8',
		clinic_sn: '3501028096',
		name: '忠孝',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '9',
		clinic_sn: '3533052704',
		name: '竹北',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '10',
		clinic_sn: '3501109041',
		name: '南京',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '11',
		clinic_sn: '3501025951',
		name: '信義富邦',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '12',
		clinic_sn: '3532017694',
		name: '桃園',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '13',
		clinic_sn: '3531019998',
		name: '板橋',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '14',
		clinic_sn: '3531034477',
		name: '永和',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '16',
		clinic_sn: '3501186128',
		name: '站前',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '17',
		clinic_sn: '3503290983',
		name: '崇德',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '19',
		clinic_sn: '3531066666',
		name: '新莊',
		active: '1',
		parent_id: '1',
	},
	{
		clinic_id: '21',
		clinic_sn: '3532027430',
		name: '中壢',
		active: '1',
		parent_id: '1',
	},
];
